exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".youtube-1 {\n  fill: #FF0000;\n}\n.youtube-2 {\n  fill: #FFFFFF;\n}", ""]);
